module.exports = __webpack_public_path__ + "6dcff12e2a688d017a494eb151a510c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qp-2-left.png
// module id = 11
// module chunks = 0